import { Center, Fieldset, Stack, StackSeparator } from '@chakra-ui/react'

import AccountsList from '@app/pages/settings/organization/components/accountsList'
import InvitationForm from '@app/pages/settings/organization/components/invitationForm'
import InvitationsList from '@app/pages/settings/organization/components/invitationsList'
import Can from '@app/shared/authorization/can'
import PageStack from '@app/shared/layout/pageStack'

const AccountsAndInvites = () => (
  <Center>
    <PageStack separator={<StackSeparator />}>
      <Can I="create" an="invitation">
        <Fieldset.Root
          borderWidth={1}
          borderStyle="solid"
          borderColor="border.default"
          borderRadius="md"
          px={6}
          p={6}
          bg="bg"
        >
          <Fieldset.Content>
            <InvitationForm />
          </Fieldset.Content>
        </Fieldset.Root>
      </Can>
      <Fieldset.Root
        borderWidth={1}
        borderStyle="solid"
        borderColor="border.default"
        borderRadius="md"
        px={6}
        p={6}
        bg="bg"
      >
        <Stack>
          <Fieldset.Legend>Team members</Fieldset.Legend>
          <Fieldset.HelperText>Manage who can access the information in DoubleLoop</Fieldset.HelperText>
        </Stack>
        <Fieldset.Content>
          <AccountsList />
        </Fieldset.Content>
      </Fieldset.Root>
      <Fieldset.Root
        borderWidth={1}
        borderStyle="solid"
        borderColor="border.default"
        borderRadius="md"
        px={6}
        p={6}
        bg="bg"
      >
        <Stack>
          <Fieldset.Legend>Invitations</Fieldset.Legend>
        </Stack>
        <Fieldset.Content>
          <InvitationsList />
        </Fieldset.Content>
      </Fieldset.Root>
    </PageStack>
  </Center>
)

export default AccountsAndInvites
